import React from "react"

import "./ExtraContent.scss"
import XMas2020 from "./XMas2020"
import ErrorBoundary from "@helper/ErrorBoundary"

const ExtraContent: React.FC<{type: Quiz.Api.ExtraContent}> = ({type}) => {
  // Extra content is non-essential decoration, and XMas2020 does risky DOM manipulation
  // (see DangrousElement) - a crash in here shouldn't take down the whole result screen.
  if (type === "xmas-2020") { return <ErrorBoundary><XMas2020 /></ErrorBoundary> }
  return null
}

export default ExtraContent
